import PencilSquareCircleFill from './PencilSquareCircleFill';

export default PencilSquareCircleFill;
